<template>
  <li
    v-if="item"
    class="messages-list-item"
    :class="{ 
      active: isMessageActive
    }"
    :style="{
      justifySelf: item.isClient ? 'flex-end' : 'flex-start',
      justifyContent: item.isClient ? 'space-between' : 'flex-start',
    }"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
      class="page-alert-error"
    />
    <div class="check">
      <CustomCheckbox
        :id="'message' + item.id"
        :input-element="item"
        @checked="changeCheckbox"
      />
    </div>
    <div class="holder-contacts" :style="{ justifyContent: item.isClient ? 'flex-end' : 'flex-start', }">
      <div v-if="!item.isClient" class="contacts-imgs">
        <div class="img-item">
          <OrangeUserIcon />
        </div>
      </div>
      <div
        class="message-item-wrapper"
        :style="{ justifyContent: item.isClient ? 'flex-end' : 'flex-start' }"
      >
        <div
          class="message-wrapper"
          :style="{ alignItems: item.isClient ? 'flex-end' : 'flex-start' }"
          @click="handleMessageClick"
        >
          <div
            class="message-item"
            :class="{
              active: isMessageActive
            }"
            :style="{ backgroundColor: item.isClient ? '#F3F8FF' : '#F6F6F6' }"
          >
            <div class="title-contact">
              <div class="span-name" :style="{ flexDirection: item.isClient ? 'row-reverse' : 'row'} ">
                <p v-if="item.senderFullName && item.senderFullName.trim().length > 0">
                  {{ item.senderFullName.trim() }}
                </p>
                <p v-else>
                  {{ item.senderName }}
                </p>
                <button @click.stop="getMetaInfo(item.id)">
                  <GreyInfoIcon />
                </button>
                <div class="span-chat">
                  <div class="chat-icon">
                    <ImgOfMessengers :name-of-messanger="item.messenger.toLowerCase()" />
                  </div>
                </div>
              </div>
              <div
                class="btn-change-message-version"
                :class="{'hidden': editMode}"
                @click="changeMessageVersion"
              >
                <button v-if="item.editedMessage && item.editedMessage !== item.message && !showOriginalMessage">
                  <span>Edited</span>
                  <ClosedEyeIcon />
                </button>
                <button v-if="item.editedMessage && item.editedMessage !== item.message && showOriginalMessage">
                  <span>Original</span>
                  <GreyOpenedEyeIcon16 />
                </button>
              </div>
            </div>
            <div class="desc-contact">
              <div class="relative">
                <span v-if="item.isBlured" class="blurred" />
                <span :style="{background: highlightBackgroundColor}" class="background" />
                <p
                  v-if="!editMode"
                  :class="{
                    underline: !!highlightColor,
                    'nocopy': item.isBlured,
                  }"
                  :data-color="highlightColor"
                  :style="{
                    color: highlightColor ? '#000' : '#696F79FF',
                    textDecorationColor: highlightColor,
                    textAlign: item.isClient ? 'right' : 'left',
                  }"
                  v-html="sanitizedMessage"
                />
                <span
                  v-else-if="item.status && item.status.toLowerCase() === 'deleted' && !item.message"
                  class="deleted-message"
                  :style="{textAlign: item.isClient ? 'right' : 'left',}"
                >Message deleted</span>
                <!--                <textarea-->
                <!--                  v-else-->
                <!--                  ref="editMessageTextarea"-->
                <!--                  type="text"-->
                <!--                  v-model="newMessage"-->
                <!--                  @input="adjustTextareaHeight"-->
                <!--                  @keydown.enter.exact.prevent="confirmMessageChange"-->
                <!--                  @keydown.shift.enter.exact="addNewLine"-->
                <!--                  @keyup.esc="cancelMessageChange"-->
                <!--                  class="edit-message-textarea"-->
                <!--                ></textarea>-->
              </div>
            </div>
            <div class="message-footer-wrapper">
              <div
                v-if="item.status && item.status.toLowerCase() === 'edited'"
                class="message-status"
              >
                <span>Edited</span>
              </div>
              <div
                v-else-if="item.status && item.status.toLowerCase() === 'deleted' && item.message"
                class="message-status"
              >
                <span>Deleted</span>
              </div>
              <div class="span-date-wrap">
                <span class="span-date">{{ parseDate(item.date) }}</span>
                <span class="span-date">{{ parseDateTime(item.date) }}</span>
              </div>
            </div>
            <div v-if="item.tags && item.tags.length" class="tag-wrap">
              <span
                v-for="(tag, index) in item.tags"
                :key="index"
                class="tag"
                v-text="tag"
              />
            </div>
          </div>
          <div v-if="item.attachments.length" class="attachment-wrapper" @click="handleAttachmentClick">
            <Attachments
              v-for="(attachment, index) in item.attachments"
              :key="attachment.id + index"
              :attachment="attachment"
              :with-recognition-text="true"
              @downloadFile="$emit('downloadFile', $event)"
            />
          </div>
        </div>
        <div v-if="item.isClient" class="contacts-imgs" style="margin-left: 10px;">
          <div class="img-item">
            <BlueUserIcon16 />
          </div>
        </div>
        <div class="message-item-info">
          <div class="message-item-info--right">
            <div class="settings-wrap">
              <button
                v-if="!editMode && !isTagging"
                v-show="false"
                class="button-comment"
                @click="handleMessageClick"
              >
                <GreyPenIcon />
              </button>
              <button
                v-else-if="!isTagging"
                v-show="false"
                class="button-comment"
                @click="confirmMessageChange"
              >
                <BlueTickIcon24 />
              </button>
              <button
                v-if="!isTagging && hasPermission(['add_comments_highlights'])"
                v-click-outside="closeTools"
                class="button-comment"
                :style="{ opacity: item.commentsCount > 0 || isHovered ? 1 : 0 }"
                @click="openTools"
              >
                <GreyCommentIcon24 />
                <span v-if="item.commentsCount > 0" class="comments-counter">{{ item.commentsCount }}</span>
              </button>
              <div class="highlight-wrapper">
                <div v-show="showTools" class="tools">
                  <span class="item" @click.stop="openComments">
                    <GreyCommentIcon24 />
                    Comment
                  </span>
                  <span class="item" @click.stop="openHighlight">
                    <GreyMarkerIcon23 />
                    Highlight
                  </span>
                </div>
                <div v-show="highlightColorsEnabled" class="tools colors">
                  <button
                    v-for="(color, index) in colors"
                    :key="index"
                    v-click-outside="closeHighlight"
                    :class="{white: color.preview === '#fff'}"
                    :style="{backgroundColor: color.preview}"
                    class="color"
                    @click="setHighlightBackground(color.origin, item.id)"
                  />
                  <button class="close" @click="deleteHighlightBackground(item.id)">
                    <GreyCloseIcon20 />
                  </button>
                </div>
                <div
                  v-if="showComments"
                  v-click-outside="closeComments"
                  class="tools comments"
                  style="height: 300px"
                >
                  <div v-if="loadFlag" class="loader-wrapper">
                    <loader :load-flag="loadFlag" />
                  </div>
                  <div
                    v-else
                    ref="commentScroll"
                    class="scroll-area"
                  >
                    <div
                      v-for="(comment, index) in comments"
                      :key="index"
                      class="comment"
                    >
                      <span class="comment-date">{{ commentDate(comment) }}</span>
                      <div class="comment-avatar">
                        <WhiteUserIcon24 />
                      </div>
                      <div class="comment-content">
                        <p class="comment-email">
                          {{ comment.email }}
                        </p>
                        <p class="comment-text">
                          {{ comment.text }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="new-comment">
                    <div class="new-comment-wrap">
                      <WhiteUserIcon24 />
                      <input
                        v-model="$v.commentText.$model"
                        placeholder="Add a comment..."
                        type="text"
                        @keyup.enter="addComment"
                      >
                      <button
                        class="send-comment-btn"
                        :disabled="$v.commentText.$invalid"
                        @click="addComment"
                      >
                        <BlueSendIcon20 />
                      </button>
                    </div>

                    <div v-if="$v.commentText.$error" class="error-wrap">
                      <span v-if="!$v.commentText.required" class="error">Field is required</span>
                      <span v-if="!$v.commentText.minLength" class="error">Minimum length is {{
                        $v.commentText.$params.minLength.min
                      }}</span>
                      <span v-if="!$v.commentText.maxLength" class="error">Maximum length is {{
                        $v.commentText.$params.maxLength.max
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="item.isPinned" class="pinned">
                <LightBluePinIcon16 />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import moment from 'moment';
import parseDate from '@/mixins/parseDate';
import parseDateTime from '@/mixins/parseTime';
import CustomCheckbox from '@/components/inputs/CustomCheckbox';
import ImgOfMessengers from '@/components/cases/case-messages/ImgOfMessangers';
import Attachments from '@/components/attachments/Attachments';
import Loader from '@/components/loader/Loader';
import {maxLength, minLength, required} from 'vuelidate/lib/validators';
import AlertErrorMsg from '@/components/profile/AlertErrorMsg.vue';
import {mapActions, mapGetters} from 'vuex';
import hasPermission from '@/utils/permission';
import debounce from '@/mixins/debounce';
import errorHandler from '@/mixins/errorHandler';
import messagesTagging from '@/mixins/messagesTagging';
import OrangeUserIcon from '@/components/icons/OrangeUserIcon.vue';
import GreyInfoIcon from '@/components/icons/GreyInfoIcon.vue';
import ClosedEyeIcon from '@/components/icons/ClosedEyeIcon.vue';
import GreyOpenedEyeIcon16 from '@/components/icons/GreyOpenedEyeIcon16.vue';
import BlueUserIcon16 from '@/components/icons/BlueUserIcon16.vue';
import GreyPenIcon from '@/components/icons/GreyPenIcon.vue';
import BlueTickIcon24 from '@/components/icons/BlueTickIcon24.vue';
import GreyCommentIcon24 from '@/components/icons/GreyCommentIcon24.vue';
import GreyMarkerIcon23 from '@/components/icons/GreyMarkerIcon23.vue';
import GreyCloseIcon20 from '@/components/icons/GreyCloseIcon20.vue';
import WhiteUserIcon24 from '@/components/icons/WhiteUserIcon24.vue';
import BlueSendIcon20 from '@/components/icons/BlueSendIcon20.vue';
import LightBluePinIcon16 from '@/components/icons/LightBluePinIcon16.vue';
import sanitizeHtml from '@/utils/sanitizeHtml';

export default {
  name: 'Message',
  emits: ['downloadFile', 'changeCheckbox', 'metaInfoPopup'],
  components: {
    LightBluePinIcon16,
    BlueSendIcon20,
    WhiteUserIcon24,
    GreyCloseIcon20,
    GreyMarkerIcon23,
    GreyCommentIcon24,
    BlueTickIcon24,
    GreyPenIcon,
    BlueUserIcon16,
    GreyOpenedEyeIcon16,
    ClosedEyeIcon,
    GreyInfoIcon,
    OrangeUserIcon,
    AlertErrorMsg,
    CustomCheckbox,
    ImgOfMessengers,
    Attachments,
    Loader
  },
  mixins: [parseDate, parseDateTime, debounce, errorHandler, messagesTagging],
  props: {
    item: {
      type: Object,
      required: true,
    },
    messageSearch: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      isHovered: false,
      loadFlag: true,
      showTools: false,
      showComments: false,
      highlightColorsEnabled: false,
      editMode: false,
      showOriginalMessage: false,
      newMessage: '',
      errorMessage: '',
      highlightBackgroundColor: this.item.highlight ? this.item.highlight : null,
      commentText: '',
      selectedText: '',
      colors: [
        {origin: 'rgba(255,236,67,0.4)', preview: 'rgba(255,236,67)'},
        {origin: 'rgba(155,126,222,0.4)', preview: 'rgba(155,126,222)'},
        {origin: 'rgba(4,83,202,0.4)', preview: 'rgba(4,83,202)'},
        {origin: 'rgba(255,149,55,0.4)', preview: 'rgba(255,149,55)'},
        {origin: 'rgba(241,16,95,0.4)', preview: 'rgba(241,16,95)'},
        {origin: 'rgba(60,193,59,0.4)', preview: 'rgba(60,193,59)'}
      ],
      comments: [],
    };
  },

  validations() {
    return {
      commentText: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(1000)
      },
    };
  },
  computed: {
    ...mapGetters('messagesTagging', {
      isTagging: 'isTagging',
      chatData: 'getChatData',
      searchMessageId: 'getSearchMessageId',
    }),
    highlightColor() {
      return this.item.highlight ? this.item.highlight : null;
    },
    sanitizedMessage() {
      return sanitizeHtml(this.messageToShow() || ' ');
    },
    isMessageActive() {
      const isTaggingActive = this.isTagging &&
        this.chatData.taggingMessageId &&
        this.item.id === this.chatData.taggingMessageId;

      const isSearchActive = this.searchMessageId && this.item.id === this.searchMessageId;

      return isTaggingActive || isSearchActive;
    }
  },
  watch: {
    item() {
      this.highlightBackgroundColor = this.item.highlight ? this.item.highlight : null;
    },
    showComments(newVal) {
      if (!newVal) {
        this.commentText = '';
        this.$v.$reset();
      }
    },
  },
  beforeDestroy() {
    this.clearSearchMessageId();
  },
  methods: {
    hasPermission,
    ...mapActions('messagesTagging', {
      setInitialState: 'setInitialState',
      clearSearchMessageId: 'clearSearchMessageId',
    }),

    handleAttachmentClick(event) {
      event.stopPropagation();
    },

    openTools() {
      this.showTools = !this.showTools;
    },

    closeTools() {
      this.showTools = false;
    },

    changeCheckbox(item) {
      this.$emit('changeCheckbox', item);
    },

    getMetaInfo(messageId) {
      const params = {
        messageId,
        caseId: this.$route.params.slug
      };

      this.$load(async () => {
        const res = await this.$api.cases.getMetaInfo(params);
        this.$emit('metaInfoPopup', res.data.body);
      });
    },

    openComments() {
      this.getComments();
      this.showComments = true;
      this.closeTools();
    },

    closeComments() {
      this.showComments = false;
    },

    commentDate(comment) {
      return moment.utc(comment.createdAt).local().format('MM DD, HH:mm');
    },

    addComment() {
      if (this.commentText) {
        this.$load(async () => {
          await this.$api.cases
            .createCommentForMessage(this.$route.params.slug, this.item.id, this.commentText)
            .then(() => {
              this.comments.push({
                email: this.$store.getters['profile/user'].email,
                createdAt: new Date(),
                id: this.comments.length + Math.random(),
                text: this.commentText,
              });

              this.item.commentsCount++;
              this.commentText = '';
              this.scrollCommentsToBottom();
              this.$v.$reset();
            }, (error) => {
              this.handleResponseError(error);
            });
        });
      }
    },

    openHighlight() {
      this.highlightColorsEnabled = true;
      this.closeTools();
    },

    closeHighlight() {
      this.highlightColorsEnabled = false;
    },

    async setHighlightBackground(color) {
      await this.$api.cases.createHighlightForMessage(this.$route.params.slug, this.item.id, color);
      this.highlightBackgroundColor = color;
      this.closeHighlightColorsMenu();
    },

    deleteHighlightBackground() {
      this.$load(async () => {
        await this.$api.cases.deleteHighlightForMessage(this.$route.params.slug, this.item.id);
      });

      this.highlightBackgroundColor = null;
      this.closeHighlightColorsMenu();
    },

    closeHighlightColorsMenu() {
      this.highlightColorsEnabled = false;
    },

    scrollCommentsToBottom() {
      setTimeout(() => {
        if (this.$refs.commentScroll) {
          this.$refs.commentScroll.scrollTo(0, 9999);
        }
      }, 0);
    },

    getComments() {
      if (this.item.commentsCount < 1) {
        this.loadFlag = false;
        this.comments = [];
        return;
      }

      this.loadFlag = true;
      this.comments = [];

      this.$load(async () => {
        const res = await this.$api.cases.getCommentsForMessage(this.$route.params.slug, this.item.id);

        this.comments = res.data.body;
        this.loadFlag = false;
        this.scrollCommentsToBottom();
      });
    },
    handleMessageClick() {
      if (this.isTagging) {
        this.$store.commit('messagesTagging/setTaggingMessageId', this.item.id);
      } else {
        this.setInitialState({
          caseId: this.$route.params.slug,
          messageId: this.item.id
        });
        if (this.$route.name !== 'Messages tagging main tab') {
          this.$router.push({name: 'Messages tagging main tab'});
        }
      }
    },
    changeFocusToTextarea() {
      this.$nextTick(() => {
        const textarea = this.$refs.editMessageTextarea;
        textarea.focus();
        textarea.setSelectionRange(textarea.value.length, textarea.value.length);
      });
    },
    adjustTextareaHeight() {
      this.$nextTick(() => {
        const textarea = this.$refs.editMessageTextarea;
        textarea.style.width = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
      });
    },
    confirmMessageChange() {
      this.$load(async () => {
        await this.$api.cases
          .editMessage(this.$route.params.slug, this.item.id, this.newMessage)
          .then(() => {
            this.editMode = false;
            this.showOriginalMessage = false;
            this.item.editedMessage = this.newMessage;
          }, (error) => {
            this.handleResponseError(error);
          });
      });
    },
    cancelMessageChange() {
      this.editMode = false;
      this.newMessage = this.item.message;
    },
    changeMessageVersion() {
      this.showOriginalMessage = !this.showOriginalMessage;
    },
    messageToShow() {
      // if (
      //   this.item.editedMessage
      //   && this.item.editedMessage !== this.item.message
      //   && !this.showOriginalMessage
      // ) {
      //   return this.highlightedMessage(this.item.editedMessage);
      // }
      return this.highlightedMessage(this.item.message);
    },
    highlightedMessage(message) {
      if (!this.messageSearch) {
        return message;
      }

      const escapedMessage = this.escapeHtml(message);
      const escapedSearchText = this.escapeRegExp(this.messageSearch);
      const regex = new RegExp(`(${escapedSearchText})`, 'gi');

      const isActiveSearchMessage = this.isTagging
        || (this.chatData.searchMessageId && this.item.id === this.chatData.searchMessageId);

      const highlightColor = isActiveSearchMessage ? 'yellow' : 'rgba(255, 255, 0, 0.4)';

      return escapedMessage.replace(
        regex,
        `<span style="background-color: ${highlightColor};">$1</span>`
      );
    },
    escapeHtml(text) {
      return text.replace(/[&<>"']/g, (match) => {
        const escapeMap = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          '\'': '&#039;',
        };
        return escapeMap[match];
      });
    },
    escapeRegExp(text) {
      return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    addNewLine(e) {
      e.preventDefault();
      this.newMessage += '\n';
      this.adjustTextareaHeight();
    }
  },
};
</script>

<style lang="scss" scoped>
.messages-list-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  transition: all .2s;
  padding: 14px 20px;
  width: 100%;

  &:hover {
    background-color: var(--case-card-hover-bg);
  }

  &:hover .settings-wrap .button-comment {
    opacity: 1;
  }

  a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    text-decoration: none;
  }

  .holder-contacts {
    display: flex;
    width: 100%;

    .contacts-imgs {
      display: flex;

      .img-item {
        overflow: hidden;
        margin-right: 10px;
        margin-left: 0;
        border: 1px solid var(--white-color);
        border-radius: 50%;
        width: 24px;
        height: 24px;

        img {
          width: 100%;
          height: 100%;
        }

        svg {
          width: 100%;
          height: 100%;
        }
      }
    }

    .message-item-wrapper {
      display: flex;
      position: relative;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;

      .message-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        width: 100%;
        cursor: pointer;

        .message-item {
          width: 50%;
          border-radius: 8px;
          padding: 5px 10px;

          .title-contact {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            width: 100%;

            button {
              display: inline-block;
              background: unset;
              line-height: initial;
              border: none;
            }

            .span-name {
              display: flex;
              align-items: center;
              font-size: 14px;
              font-weight: 700;
              gap: 5px;

              p {
                margin: 0;
              }

              button {
                display: flex;
                justify-content: center;
                align-items: center;
                border: none;
                width: 12px;
                height: 12px;
                padding: 0;
                background: unset;
                line-height: initial;

                svg {
                  min-width: 16px;
                  min-height: 16px;
                }
              }

              .span-chat {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                font-size: 10px;
                font-weight: 600;
                text-transform: uppercase;

                .chat-icon {
                  width: 16px;
                  height: 16px;
                }
              }
            }

            .btn-change-message-version {
              background: unset;
              line-height: initial;
              border: none;
              color: var(--light-gray);
              font-size: 10px;

              &.hidden {
                visibility: hidden;
              }

              button {
                display: flex;
                align-items: center;
                gap: 4px;
                color: var(--light-gray);
              }

              span {
                border-bottom: 1px solid var(--light-gray);
              }
            }
          }

          .desc-contact {
            width: 100%;

            p, textarea {
              width: 100%;
              margin: 5px 0 0;
              font-size: 12px;
              font-weight: 500;
              line-height: 160%;
              color: var(--secondary-text-color);
              white-space: pre-wrap;
            }

            .relative {
              position: relative;

              .blurred {
                position: absolute;
                z-index: 0;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-color: var(--black-color);
              }

              .background {
                position: absolute;
                z-index: 0;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
              }

              .underline {
                text-decoration: underline;
                text-underline-offset: 2px;
              }

              .edit-message-textarea {
                display: block;
                border: transparent;
                border-radius: 0 !important;
                height: auto;
                padding: 0 !important;
                width: 100%;
              }
            }
          }

          .tag-wrap {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-right: 15px;

            .tag {
              font-weight: 500;
              font-size: 10px;
              line-height: 16px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #FFFFFF;
              padding: 2px 4px;
              background-color: #F1105F;
              text-transform: capitalize;
              border-radius: 4px;
              margin-bottom: 4px;

              &:not(:last-child) {
                margin-right: 8px;
              }
            }
          }

          .span-date-wrap {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-bottom: 5px;

            .span-date {
              display: inline-block;
              white-space: nowrap;
              font-size: 11px;
              font-weight: 500;
              color: var(--secondary-text-color);
              margin-right: 8px;

              &:last-child {
                margin-right: 0;
              }
            }
          }
        }

        .attachment-wrapper {
          display: flex;
          flex-direction: column;
        }
      }

      .message-item-info {
        display: flex;
        position: relative;
        justify-content: flex-start;
        align-items: center;

        .message-item-info--right {
          display: flex;
          flex-direction: column;
          align-items: center;

          .settings-wrap {
            display: flex;

            .button-comment {
              display: flex;
              align-items: center;
              border: none;
              background-color: transparent;
              opacity: 0;


              &:hover svg path {
                stroke: var(--accent-color);
              }

              &:hover .comments-counter {
                color: var(--accent-color);
              }

              svg path,
              .comments-counter {
                transition: all .2s;
              }

              .comments-counter {
                font-weight: 500;
                font-size: 12px;
                line-height: 16px;
                color: #696F79;
              }
            }

            .tools {
              position: absolute;
              z-index: 10;
              top: 50%;
              right: 0;
              justify-content: center;
              align-items: center;
              transition: 0.2s all;
              border: 1px solid var(--case-btn-border-color);
              border-radius: 8px;
              padding: 8px;
              background-color: var(--white-color);
              font-size: 12px;

              .item {
                display: flex;
                align-items: center;
                cursor: pointer;
                font-weight: 500;
                color: var(--secondary-text-color);
                gap: 6px;
                transition: .2s all;

                svg path {
                  transition: .2s all;
                }

                &:not(:last-child) {
                  margin-bottom: 12px;
                }

                &:hover {
                  color: var(--accent-color);
                }

                &:hover svg path {
                  stroke: var(--accent-color);
                }
              }
            }

            .colors {
              display: flex;
              align-items: center;
              transform: translate(-10%, -50%);
              gap: 16px;

              .close {
                border: none;
                width: fit-content;
                padding: 0;
                background-color: transparent;
              }

              .color {
                border: 1px solid transparent;
                border-radius: 50%;
                width: 16px;
                height: 16px;

                &.white {
                  border-color: var(--case-btn-border-color);
                }

                &:hover,
                &.active {
                  border-color: #373c44;
                }
              }
            }

            .comments {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              width: 403px;

              .loader-wrapper {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .scroll-area {
                width: 100%;
                max-height: 296px;
                overflow-y: auto;
                margin-bottom: 15px;

                /* width */

                &::-webkit-scrollbar {
                  width: 5px;
                }

                /* Track */

                &::-webkit-scrollbar-track {
                  background: #f1f1f1;
                  border-radius: 15px;
                }

                /* Handle */

                &::-webkit-scrollbar-thumb {
                  background: var(--accent-color);
                  border-radius: 15px;
                }

                .comment {
                  display: flex;
                  position: relative;
                  margin-bottom: 38px;

                  &:last-child {
                    margin-bottom: 20px;
                  }

                  &-date {
                    position: absolute;
                    top: 0;
                    right: 0;
                    transform: translate(-10%, 50%);
                    font-size: 10px;
                    color: var(--light-gray);
                  }

                  &-avatar {
                    margin-right: 8px;
                  }

                  &-content {
                    width: 90%;
                    word-break: break-word;
                  }

                  &-email {
                    overflow-x: hidden;
                    margin-bottom: 0;
                    max-width: 280px;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 23px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }

                  &-text {
                    overflow: hidden;
                    margin: 0;
                    font-size: 12px;
                    font-weight: 500;
                  }
                }
              }

              .new-comment {
                width: 100%;

                .new-comment-wrap {
                  display: flex;
                  align-items: center;
                  width: 100%;
                  gap: 8px;

                  .send-comment-btn {
                    padding: 0;
                    border: none;
                    background-color: transparent;

                    &:disabled svg path {
                      fill: var(--background-button-disabled-color);
                    }

                    &:not(:disabled):hover svg path {
                      opacity: 0.5;
                    }

                    svg path {
                      transition: all .5s;
                    }
                  }
                }

                .error-wrap {
                  margin-top: 6px;
                  margin-left: 10px;

                  .error {
                    display: inline;
                  }
                }
              }

              &.top {
                top: unset;
                bottom: 100%;
              }

              &.bottom {
                top: 100%;
                bottom: unset;
              }

              input {
                border: none;
                width: 100%;
                height: 25px;
                padding: 0;
                font-size: 12px;
                line-height: 19px;
              }
            }

            .pinned {
              display: flex;
              align-items: center;
              gap: 5px;
            }
          }
        }
      }
    }
  }
}

.messages-list-item {
  &.active {
    background-color: #e3f2fd;
    border-left: 3px solid #2196f3;
  }
}

.message-item {
  &.active {
    box-shadow: 0 2px 8px rgba(4, 52, 90, 0.3);
  }
}

button[disabled] {
  cursor: not-allowed;
}

.message-footer-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.message-status {
  font-weight: 400;
  font-style: italic;
  font-size: 12px;
  line-height: 16px;
  color: var(--light-gray);
}

.deleted-message {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: var(--light-gray);
}
</style>
